const InterventionPlanTabs = Object.freeze({
  InterventionPlanManagement: 0,
  InterventionPlanSignature: 1,
  InterventionPlanDiagnosis: 2,
});

export default InterventionPlanTabs;
